export default function () {
    return (
        <svg width="1em" height="1em" viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="59" cy="59" r="55" fill="#FFE8B8" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.3058 39.4635C49.3058 34.1095 53.6461 29.7693 59 29.7693C64.3539 29.7693 68.6942 34.1095 68.6942 39.4635V41.9423C68.6942 41.9869 68.6926 42.0312 68.6895 42.075H73.3642C75.5278 42.075 77.2817 43.829 77.2817 45.9925L81 77.3326C81 79.4962 79.2461 81.2501 77.0825 81.2501H40.9175C38.7539 81.2501 37 79.4962 37 77.3326L40.7183 45.9925C40.7183 43.829 42.4722 42.075 44.6358 42.075H49.3105C49.3074 42.0312 49.3058 41.9869 49.3058 41.9423V39.4635ZM64.9759 41.9423C64.9759 41.9869 64.9774 42.0312 64.9805 42.075H53.0195C53.0226 42.0312 53.0242 41.9869 53.0242 41.9423V39.4635C53.0242 36.1631 55.6996 33.4876 59 33.4876C62.3004 33.4876 64.9759 36.1631 64.9759 39.4635V41.9423ZM50.8923 62.2899L55.0168 48.7446H66.3593L60.1725 58.122L68.4215 60.206L55.0168 75.8351L58.1103 63.3318L50.8923 62.2899Z"
                fill="url(#paint0_linear_7_8793)"
            />
            <defs>
                <linearGradient id="paint0_linear_7_8793" x1="59" y1="29.7693" x2="59" y2="81.2501" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#888888" />
                    <stop offset="1" />
                </linearGradient>
            </defs>
        </svg>
    );
}
